module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightrain@3-6631531dd5a21af1243ba865d9b26e7b.png";